<script setup>
import PgeButton from '../../../../pge-components/pge-button.vue';
const props = defineProps({
	currentFormStepData: {
		type: Object,
		default: {}
	},
});

function handleRedirect(path) {
	window.location.href = path;
}
</script>

<template>
	<div class="form">
		<div class="form__title">
			<template v-if="props.currentFormStepData.user_exists">
				You're already registered!
			</template>
			<template v-if="props.currentFormStepData.user_returned">
				Welcome Back
			</template>
			<template v-if="props.currentFormStepData.user_deactivated">
				Deactivated
			</template>
		</div>
		<div class="form__content">
			<template v-if="props.currentFormStepData.user_deactivated">
				<div class="form__content__error">
					This user has been deactivated.
				</div>
			</template>
			<template v-else-if="props.currentFormStepData.user_returned">
				Welcome Back
			</template>
			<template v-else>
				It looks like you're already signed up with this email address.
				<span class='form__hyperlink' @click="() => { handleRedirect('/login') }">Log In</span>
			</template>
		</div>
		<pge-button label="Close" @click="() => { handleRedirect('/') }" />
	</div>
</template>

<style lang="scss" scoped>
.form {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 22px;

	&__title {
		font-style: normal;
		font-weight: 800;
		font-size: 24px;
		line-height: 29px;
		text-align: center;
		color: #000;
	}

	&__content {
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 19px;
		text-align: center;
		color: #000;

		&__title {
			font-style: normal;
			font-weight: 800;
			font-size: 24px;
			line-height: 29px;
			color: #000;
		}

		&__text {
			font-size: 16px;
			line-height: 24px;
			color: #000;
			text-align: center;
			word-wrap: break-word;
		}

		&__error {
			color: red;
		}
	}

	&__hyperlink {
		color: #5E2F78;
		font-weight: 600;
		cursor: pointer;
	}
}
</style>